import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bbe9d768"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_w"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "box_right"
};
const _hoisted_5 = {
  class: "name_s text-cut"
};
const _hoisted_6 = {
  class: "name"
};
const _hoisted_7 = {
  key: 0,
  class: "name"
};
const _hoisted_8 = {
  class: "mesage"
};
const _hoisted_9 = {
  class: "item_s"
};
const _hoisted_10 = {
  class: "last_time"
};
const _hoisted_11 = {
  key: 0,
  class: "loading"
};
const _hoisted_12 = {
  key: 1,
  class: "no-more"
};
import { debounce } from "lodash";
import { getchat_list } from "@/service/modules/alllist";
import { ref, watch } from "vue";
import { Search } from "@element-plus/icons-vue";
import userimg from "../../assets/user.png";
import { useScrollLoad } from "@/hooks/useScrollLoad";
import useRoleStore from "@/store/modules/role";
export default /*#__PURE__*/_defineComponent({
  __name: 'user-item',
  props: {
    activeName: {
      type: Number,
      default: 1
    },
    from: {
      type: String,
      default: "" // 添加默认值
    }
  },

  emits: ["set_actives"],
  setup(__props, {
    emit: __emit
  }) {
    const roleStore = useRoleStore();
    const props = __props;
    const search = ref("");
    const actives = ref("");
    // const chat_list = ref([]);
    // const loading = ref(false);
    const scrollContainer = ref(null);
    // 监听 props.from 的变化
    watch(() => props.from, async newValue => {
      if (newValue) {
        await reset();
      }
    });
    // 监听 props.activeName 的变化
    watch(() => props.activeName, async () => {
      if (props.from) {
        await reset();
      }
    });
    // 使用滚动加载 Hook
    const {
      list,
      loading,
      hasMore,
      reset,
      loadData
    } = useScrollLoad({
      pageSize: 20,
      requestData: getchat_list,
      searchParams: () => ({
        type: props.activeName,
        from: props.from,
        search: search.value
      }),
      autoLoad: Boolean(props.from)
    });
    watch(() => list.value, newValue => {
      if (newValue && newValue.length > 0) {
        get_select_one();
      } else {
        emit("set_actives", {});
      }
    });
    const get_select_one = async () => {
      actives.value = list.value[0].id;
      emit("set_actives", list.value[0]);
    };
    const handScroll = () => {
      if (!scrollContainer.value) return;
      // 获取滚动容器
      const container = scrollContainer.value;
      // 计算滚动位置
      const scrollTop = container.scrollTop; // 当前滚动距离
      const scrollHeight = container.scrollHeight; // 总高度
      const clientHeight = container.clientHeight; // 可视区高度
      if (scrollHeight - scrollTop - clientHeight <= 50) {
        loadData();
      }
    };
    // 搜索变化的防抖函数
    const changes = debounce(() => {
      reset();
    }, 300);
    const get_message = item => {
      let messages = JSON.parse(item.last_content);
      if (item.last_msgtype == "text") {
        return messages.content;
      }
      if (item.last_msgtype == "emotion") {
        return "[表情]";
      }
      if (item.last_msgtype == "image") {
        return "[图片]";
      }
      if (item.last_msgtype == "voice") {
        return "[语音]";
      }
      if (item.last_msgtype == "weapp") {
        return "[小程序消息]";
      }
    };
    const get_lasttime = item => {
      return item.last_time.slice(5, 10);
    };
    const emit = __emit;
    const set_actives = item => {
      actives.value = item.id;
      emit("set_actives", item);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        modelValue: search.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
        class: "seach",
        placeholder: "搜索客户昵称/备注",
        "prefix-icon": _unref(Search),
        onInput: _unref(changes)
      }, null, 8, ["modelValue", "prefix-icon", "onInput"]), _createElementVNode("div", {
        class: "user_s_1",
        ref_key: "scrollContainer",
        ref: scrollContainer,
        onScroll: handScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item-box", item.id === actives.value ? 'item-box-bg' : '']),
          onClick: $event => set_actives(item)
        }, [_createElementVNode("img", {
          class: "ac_img",
          src: __props.activeName == 1 && item.customer ? item.customer.avatar : _unref(userimg),
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(__props.activeName == 1 && item.customer ? item.customer.name : item.user ? item.user.name : ""), 1), __props.activeName == 1 && item.customer ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(item.customer.remark) + ")", 1)) : _createCommentVNode("", true), _createElementVNode("span", {
          class: _normalizeClass(["tag", !item.user ? 'color_1' : 'color_2'])
        }, _toDisplayString(!item.user ? "@微信" : "@" + item.user.dept_name), 3)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(get_message(item)), 1), _createElementVNode("span", _hoisted_10, _toDisplayString(get_lasttime(item)), 1)])])], 10, _hoisted_2);
      }), 128)), _unref(loading) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [_createTextVNode("加载中...")])), [[_directive_loading, _unref(loading)]]) : _createCommentVNode("", true), !_unref(hasMore) && _unref(list).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 没有更多数据了 ")) : _createCommentVNode("", true)], 544)])), [[_directive_loading, _unref(roleStore).loading1]]);
    };
  }
});